module.exports = __webpack_public_path__ + "img/cartao_qrcode.76a7b769.png";